export default [

    {
        title: 'Profil Utilisateur',
        route: 'profile',
        icon: 'UserIcon',
        module: 'profil',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper','Technician']

    }
    
    //   ],
    // },

]